import { styled } from '@mui/material';

const PREFIX = 'ContactAdminOrInquireLicensing';

export const contactAdminClasses = {
  alertStyle: `${PREFIX}-alertStyle`,
};

export const ContactAdminRoot = styled('div')(({ theme }) => ({
  [`& .${contactAdminClasses.alertStyle}`]: {
    color: theme.palette.error.pink,
    fontSize: '1rem',
    padding: '1rem',
    border: `2px solid ${theme.palette.error.pink}`,
  },
}));
